import { useContext } from "react";

import { useNavigate } from "react-router-dom";

import { usePutPatientMarkAsPrioMutation } from "api/hooks/usePutPatientMarkAsPrioMutation";
import { useProfileContext } from "contexts/ProfileContext";
import { CurrentPatientContext } from "utils/contexts";

export const usePatientActions = () => {
  const { patient, previousTreatmentId } = useContext(CurrentPatientContext);
  const { profile } = useProfileContext();
  const navigate = useNavigate();

  const putPatientMarkAsPrioMutation = usePutPatientMarkAsPrioMutation({
    patientId: patient?.id,
    therapistId: profile?.id,
    therapistMarket: profile?.market,
    previousTreatmentId,
  });

  const togglePriority = () => {
    putPatientMarkAsPrioMutation.mutate({
      data: { prio: !patient.prio },
    });
  };

  const handleOpenMessages = () => {
    navigate(`/messages/patients/${patient.id}`);
  };

  return {
    togglePriority,
    handleOpenMessages,
    isPriorityLoading: putPatientMarkAsPrioMutation.isLoading,
  };
};
